export const getUserScopedStorageKey = (baseKey) => {
  try {
    const raw = localStorage.getItem('user')
    const user = raw ? JSON.parse(raw) : null
    const uid = user?.user_id
    if (uid != null && uid !== '') return `${baseKey}_u${uid}`
  } catch (_) {
    // Fallback to global key when user parsing fails.
  }
  return `${baseKey}_guest`
}

